import { render } from "./DetailedInformationalLayout.vue?vue&type=template&id=535dfee8&scoped=true&ts=true"
import script from "./DetailedInformationalLayout.vue?vue&type=script&lang=ts"
export * from "./DetailedInformationalLayout.vue?vue&type=script&lang=ts"

import "./DetailedInformationalLayout.vue?vue&type=style&index=0&id=535dfee8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535dfee8"]])

export default __exports__